/**
 * @fileoverview Features grid component showing ISCRI key features
 * @author SKEMA CANADA
 */

import ContentCard from "@components/ui/ContentCard";
import "./styles/FeaturesGrid.css";

/**
 * Features grid component with key ISCRI capabilities
 * @returns {JSX.Element} Features grid component
 */
const FeaturesGrid = () => {
  const features = [
    {
      icon: "📊",
      title: "Real-Time Tracking",
      description:
        'ISCRI is a new "Interstate Conflictual Relations Index" which tracks in real time geopolitical tensions between countries.',
    },
    {
      icon: "🗃️",
      title: "Data Source",
      description:
        "It is based on the automatic coding of media news recorded in the Global Data on Events, Location, and Tone (GDELT) database.",
    },
    {
      icon: "🔍",
      title: "Comprehensive Analysis",
      description:
        "Our Index can distinguish between verbal and material conflicts, follows best practices, and is available for virtually all country-pairs in the world since 2015.",
    },
    {
      icon: "⚠️",
      title: "Early Warning",
      description:
        "It provides a novel early warning synthetic signal specific to each country-pair.",
    },
  ];

  return (
    <section className="features-section reveal-element">
      <div className="container">
        <div className="features">
          {features.map((feature, index) => (
            <ContentCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              layout="centered"
              animationDelay={0.1 * (index + 1)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
